import * as Sentry from '@sentry/react';
import localforage from 'localforage';

import {
  REDUX_STORAGE_KEY,
  REDUX_WALLET_SYNC_KEY,
  LEDGER_CACHE_STORAGE_KEY,
  VIEW_ADDRESS_STORAGE_KEY,
} from '../storage/constants';

// read old local storage before moving to indexed db
const reduxStorage = localStorage.getItem('redux-storage-v2');
const viewAddressStorage = localStorage.getItem('view-address-v1');
const walletCacheStorage = localStorage.getItem('wallet-cache-storage-v2');
const ledgerCacheStorage = localStorage.getItem('ledger-cache-storage-v2');

localforage.config({
  driver: localforage.INDEXEDDB,
  name: 'cspr.live',
  version: 1.0,
  storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
});

const init = async () => {
  try {
    // all moved without error so safe to clear the storage
    clearOldKeysInStorage();
    // recreate local storage
    reduxStorage != null &&
      localStorage.setItem(REDUX_STORAGE_KEY, reduxStorage);
    walletCacheStorage != null &&
      localStorage.setItem(REDUX_WALLET_SYNC_KEY, walletCacheStorage);
    viewAddressStorage != null &&
      localStorage.setItem(VIEW_ADDRESS_STORAGE_KEY, viewAddressStorage);
    ledgerCacheStorage != null &&
      localStorage.setItem(LEDGER_CACHE_STORAGE_KEY, ledgerCacheStorage);
  } catch (err) {
    Sentry.captureException(err);
  }
};

init();

/** helpers */

function clearOldKeysInStorage() {
  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index);
    [
      'redux-storage',
      'view-address',
      'wallet-cache-storage',
      'ledger-cache-storage',
      'faucet-history',
      'cache-storage',
      'global-cache-storage',
    ].forEach((oldKey) => {
      if (key?.startsWith(oldKey)) {
        localStorage.removeItem(key);
      }
    });
  }
}
